import React, { useEffect } from 'react';
import { track as mixpanelTrack } from '../../../lib/mixpanel';
import { EntryProps } from '../../../lib/interfaces';
import { PageHeader } from '../PageHeader';
import { StepsToReward } from '../StepsToReward';
import { Affiliate } from '../Affiliate';
import { Invitation } from '../Invitation';

export const ReferralProgram = (props: EntryProps) => {
  const { socialLinks, inviteLink, user } = props;

  useEffect(() => {
    mixpanelTrack('Referral Page Inviter - Referral Page Inviter - View', {});
  }, []);

  return (
    <>
      <PageHeader />

      {!!socialLinks && !!inviteLink && <Invitation socialLinks={socialLinks} user={user} inviteLink={inviteLink} />}

      <StepsToReward />
      <Affiliate />
    </>
  );
};
